import * as go from 'gojs';

const $ = go.GraphObject.make;

const KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
go.Shape.defineFigureGenerator('BpmnActivityLoop', (shape, w, h) => {
  const geo = new go.Geometry();
  const r = 0.5;
  const cx = 0; // offset from Center x
  const cy = 0; // offset from Center y
  const d = r * KAPPA;
  const mx1 = (0.4 * Math.SQRT2) / 2 + 0.5;
  const my1 = 0.5 - (0.5 * Math.SQRT2) / 2;
  const x1 = 1;
  const y1 = 0.5;
  const x2 = 0.5;
  const y2 = 0;
  const fig = new go.PathFigure(mx1 * w, (1 - my1) * h, false);
  geo.add(fig);

  fig.add(
    new go.PathSegment(
      go.PathSegment.Bezier,
      x1 * w,
      y1 * h,
      x1 * w,
      0.7 * h,
      x1 * w,
      y1 * h,
    ),
  );
  fig.add(
    new go.PathSegment(
      go.PathSegment.Bezier,
      (x2 + cx) * w,
      (y2 + cx) * h,
      (0.5 + r + cx) * w,
      (0.5 - d + cx) * h,
      (0.5 + d + cx) * w,
      (0.5 - r + cx) * h,
    ),
  );
  fig.add(
    new go.PathSegment(
      go.PathSegment.Bezier,
      (0.5 - r + cx) * w,
      (0.5 + cy) * h,
      (0.5 - d + cx) * w,
      (0.5 - r + cy) * h,
      (0.5 - r + cx) * w,
      (0.5 - d + cy) * h,
    ),
  );
  fig.add(
    new go.PathSegment(
      go.PathSegment.Bezier,
      (0.35 + cx) * w,
      0.9 * h,
      (0.5 - r + cx) * w,
      (0.5 + d + cy) * h,
      (0.5 - d + cx) * w,
      0.9 * h,
    ),
  );
  // Arrowhead
  fig.add(new go.PathSegment(go.PathSegment.Move, (0.25 + cx) * w, 0.8 * h));
  fig.add(new go.PathSegment(go.PathSegment.Line, (0.35 + cx) * w, 0.9 * h));
  fig.add(new go.PathSegment(go.PathSegment.Line, (0.2 + cx) * w, 0.95 * h));
  return geo;
});

export const nodeRotateAdornmentTemplate = $(
  go.Adornment,
  {
    locationSpot: go.Spot.Center,
  },
  $(go.Shape, 'BpmnActivityLoop', {
    width: 25,
    height: 25,
    cursor: 'pointer',
    background: 'transparent',
    stroke: 'dodgerblue',
    strokeWidth: 2,
  }),
  $(go.Shape, 'Circle', {
    width: 25,
    height: 25,
    cursor: 'pointer',
    background: 'transparent',
    fill: 'transparent',
    stroke: null,
    strokeWidth: 0,
  }),
);
